export default __webpack_public_path__ + "static/media/0.7e6f7d5d.jpg";